import React from "react";

const ChevronUp = () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="13.801" height="7.885" viewBox="0 0 13.801 7.885">
        <path id="chevron-up-solid" d="M38.129,96.314a.987.987,0,0,1,1.4,0l5.913,5.913a.986.986,0,0,1-1.4,1.4L38.825,98.4l-5.217,5.214a.986.986,0,0,1-1.4-1.4l5.913-5.913Z" transform="translate(-31.925 -96.025)" fill="currentColor"/>
    </svg>

}

export default ChevronUp;
